<script>
import { api } from "@/store/modules/audit";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(api.namespace, [
      api.getters.getAuditId,
      api.getters.getAuditDocumentData
    ]),
    auditId() {
      return this.getAuditId;
    },
    currentAudit() {
      return this.getAuditDocumentData;
    },
    auditItems() {
      const audit = this.currentAudit;
      if (audit) {
        return audit.audit_items;
      } else {
        return {};
      }
    }
  }
};
</script>
